<!-- Tool Status at Top (real-time during streaming) -->
<app-tool-status
  *ngIf="message.metadata?.tool_calls?.length > 0 || message.metadata?.streaming_tool_status === 'executing'"
  [toolCalls]="message.metadata?.tool_calls || []"
  [displayMode]="toolDisplayMode"
  [status]="getToolStatus()">
</app-tool-status>

<!-- Message Content -->
<div class="doc-markdown" 
     *ngIf="message">
  <markdown 
    [data]="getDisplayContent()" 
    clipboard 
    katex
    mermaid
    [mermaidOptions]="mermaidOptions">
  </markdown>
</div>

<!-- File Attachment -->
<div *ngIf="message?.uploaded_file">
  <app-file-attachment
    [file]="message.uploaded_file"
    [showDeleteButton]="false"
    (deleteFile)="onDeleteFile($event)"
  ></app-file-attachment>
</div>

<!-- Message Actions -->
<div *ngIf="message && isBot && message.content?.trim()">
  <app-message-actions
    [message]="message"
    [filteredMessages]="filteredMessages"
    [activeMessageId]="activeMessageId"
    [copiedMessageId]="copiedMessageId"
    [exportedMessageId]="exportedMessageId"
    (copySuccess)="onCopySuccess()"
    (exportSuccess)="onExportSuccess($event)"
    (exportError)="onExportError($event)"
  ></app-message-actions>
</div>
